// src/utils/utmWhatsApp.ts
import i18n from "../../i18n";

export type CpKey =
  | "cp1"  | "cp2"  | "cp3"  | "cp4"  | "cp5"
  | "cp6"  | "cp7"  | "cp8"  | "cp9"  | "cp10"
  | "cp11" | "cp12" | "cp13" | "cp14" | "cp15"
  | "cp16" | "cp17" | "cp18" | "cp19" | "cp20"
  | "cp21";

function getQueryParam(name: string, url?: string): string | null {
  try {
    const u = new URL(url ?? window.location.href);
    const v = u.searchParams.get(name);
    if (v) return v;

    // На всякий случай — ищем и в hash (#/?utm_source=...)
    if (u.hash) {
      const h = new URL(u.origin + u.hash.replace(/^#/, ""));
      return h.searchParams.get(name);
    }
    return null;
  } catch {
    return null;
  }
}

export function resolveCpKey(): CpKey | null {
  const raw = (getQueryParam("utm_source") || "").trim().toLowerCase();
  if (!raw) return null;
  const m = raw.match(/^cp(\d{1,2})$/i);
  if (!m) return null;
  const n = Number(m[1]);
  if (n < 1 || n > 21) return null;
  return (`cp${n}` as CpKey);
}

export function getWhatsappPrefillMessage(): string {
  const key = resolveCpKey();
  const tKey = key ? `landing:whatsapp.${key}` : "landing:whatsapp.default";
  const v = i18n.t(tKey);
  // If a campaign key is missing in the current locale, i18next returns the
  // key itself — fall back to the localized default.
  if (!v || v === tKey) return i18n.t("landing:whatsapp.default");
  return v;
}

export function buildWhatsappUrl(phoneE164: string): string {
  const text = getWhatsappPrefillMessage();
  const encoded = encodeURIComponent(text);
  return `https://wa.me/${phoneE164}?text=${encoded}`;
}
